import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import * as moment from 'moment/moment';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Popup } from 'ng2-opd-popup';
import {CsvService} from 'angular2-json2csv';
import * as XLSX from 'xlsx';
import { DialogService,DialogComponent} from 'ng2-bootstrap-modal';
import {AlertHistoryComponent} from '../alert-history/alert-history.component';
import { IOption } from 'ng-select';

@Component({
  selector: 'app-status-report-one-month-before',
  templateUrl: './status-report-one-month-before.component.html',
  styleUrls: ['./status-report-one-month-before.component.scss']
})
export class StatusReportOneMonthBeforeComponent implements OnInit {
  loading:boolean=true;
  ServicecontractexpiryDropdown:Array<IOption>=[];
  selectOptions:any = 'Expired';
  response:any[] = [];
  ListOfCustomerMaster:any[] = [];
  customerDetails:any[] =[];
  daysCount:any;
  todaydate:any = moment().format('YYYY-MM-DD');

  histroy:any[]=[];
  clientName:any;
  serialNumber:any;
  mcLocation:any;
  phoneNumber:any;
  email:any;
  make:any;
  model:any;
  hmrHours:any;
  technicianName:any;
  lastServiceType:any;
  lastServiceHours:any;
  yearOfManufacture:any;
  branch:any;
  serviceContractOfferedYear:any;
  contractReference:any;
  noofServiceContractYears:any;
  startDate:any;
  endDate:any;
  noOfservice:any;
  serviceRemainderDays:any;
  currentService:any;  
  ListserviceDetails:any;
  histroyPP:any[] = [];
  ListOfFinalData:any[]=[];
  @ViewChild('Histroy') Histroy: Popup;
  @ViewChild('ContractExtension') ContractExtension: Popup;
  startingCount:number = 0;
  endingCount:number = 0;
  p: number = 1;
  newextension_err:boolean=false;
  newserialNumber:number;
  newstartdate:any;
  newenddate:any;
  newextensiondate:any;
  extensionUpdateId;
  reqmodelId;
  reqMakeId;
  ServiceContractExtend = [];
  ListAllServcieType = [];
  histroyPr = [];
  ListOfExpiryreport = [];
  ListOfNeedToRenewal = [];
  ListTechnicianName = [];
  techinicianDetails = [];
  orgId:number;
  userId:number;
  ListAllHistroyDetails = [];
  AllMakedetails =[];
  AllModalDetails=[];
  listContractLevel=[];
  finalArr=[];
  ListbranchDetails:any[]=[];
  constructor(private dialogservice:DialogService,private http: Http,private router:Router,private csvService: CsvService,private route : ActivatedRoute) { }
	


	ngOnInit() {
    this.loading=true;
    if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
        window.location.href = 'https://still.alshirawi.com/highmessaging/';
      } else {
        this.orgId=this.route.params['value'].orgId;
        this.userId=this.route.params['value'].userId;
        console.log('OrgId '+ this.orgId);
        console.log('UserId '+ this.userId);
      }
		this.getAllDetailsFromCustomerMaster();
	  // this.getAlldetails();
    
    // this.getAllServiceTypeDetails();
    // this.getTechnicianName();
    // this.getBranchDetails();
    // this.getmodeldetails();
    // this.getmakedetails();
   
    let pusharr=[];
    pusharr.push({'value':"Expired",'label':"Expired"},
      {'value':"Need To Renewal",'label':"Need To Renewal"});  
      this.ServicecontractexpiryDropdown=pusharr;
   
  
	}

  extensiondate(date) {
    if(date < this.newenddate) {
      alert('Extension date should be greater than End date');
      this.newextensiondate = '';
    } 
  }

  getBranchDetails(){
    let obj={
     'orgId':this.orgId
    }
    return this.http.post('/api/getbranchdetails',obj).subscribe(res=>{
       this.ListbranchDetails=res.json();
       this.getmakedetails();
    },(err)=> {
    this.getmakedetails();
  })
   }

  getmodeldetails() {
   // this.loading=true;
      let modelObj = {
        'orgId':this.orgId
      }
      return this.http.post('/api/getModelDetails', modelObj).subscribe(
       res => {
    
         this.AllModalDetails = [];
         let response = res.json();
         if(response.length>0) {
           this.AllModalDetails =response;
           //this.model = response[0].model.toUpperCase();;
         }
         this.getAlldetails();
       },(err)=>{
         this.loading=false;
         this.getAlldetails();
       })
    }

    getmakedetails() {
  
      let makeObj = {
        'orgId':this.orgId
      }
      return this.http.post('/api/getMakedetails', makeObj).subscribe(
       res => {
      
         this.AllMakedetails=[];
         let response = res.json();
         if(response.length>0) {
           this.AllMakedetails = response;
           
         }
         this.getmodeldetails();
       },(err)=>{
         this.loading=false;
         this.getmodeldetails();
       })
    }
  

  getCount(){
     if(this.p < Math.ceil(this.response[1].register.length/10)){
       this.startingCount = (this.p-1)*10;
       if(this.startingCount == 0){
         this.startingCount = 1;
       }
       this.endingCount = this.p*10;
     } else if(this.p == Math.ceil(this.response[1].register.length/10)){
       let count = this.response[1].register.length%10;
       this.startingCount = (this.p-1)*10;
       this.endingCount = this.startingCount + count;
       if(this.startingCount == 0){
         this.startingCount = 1;
         this.endingCount = count;
       }
     }
  }
  getAllServiceTypeDetails() {
  //  this.loading=true;
     let serviceObj = {
        'orgId':this.orgId
      }
      return this.http.post('/api/getServiceTypedetails', serviceObj).subscribe(
        res => {
        // this.loading=false;
           this.ListAllServcieType = res.json();
           this.getTechnicianName();
        },(err)=>{
          this.loading=false;
           alert('unable to load make values')
           this.getTechnicianName();
        })
  }



  showAlert(){
    this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',values:this.ListAllHistroyDetails,contractlevelArr:this.listContractLevel,'finalArr':this.finalArr,'customIndex':0})
  }

  exportToExcel(event) {
    console.log('1 ', this.ListOfFinalData)
    let exportData = [];
    exportData = this.ListOfFinalData;
    for(let i=0;i<exportData.length;i++){
      if(exportData[i].ENDDATE <= this.todaydate) {
        exportData[i].status = 'Expired';
      } else if(exportData[i].ENDDATE > this.todaydate && exportData[i].days <=30 ) {
        exportData[i].status = 'Need to renewal';
      } else {
        exportData[i].status = 'Active';
      }
    }
    //this.csvService.download(exportData, 'Expiry Report');
    let	data=[];
		// let Reportstartdate = moment(this.fromDate).format('D MMM YYYY');
		// let Reportenddate = moment(this.toDate).format('D MMM YYYY');
		let title='Expiry Report.xlsx'
		data.push(['Expiry Report'])
		data.push([])
		data.push(['S NO','SERIAL NUMBER','CLIENT NAME','LOCATION',"CONTRACT REFERENCE",'CURRENT SERVICE',"CONTRACT LEVEL",'PMA START DATE','PMA END DATE','DAYS REMAINING','STATUS'])
		for(let i=0;i<exportData.length;i++) {
		data.push([i+1,exportData[i].serial_Number,exportData[i].client_Name,exportData[i].mcLocation,exportData[i].contract_Reference,exportData[i].serviceScheduleDay,exportData[i].contractLevel,exportData[i].start_Date,exportData[i].end_Date,exportData[i].days,exportData[i].status])
		}
		let wb: XLSX.WorkBook =XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

		XLSX.utils.book_append_sheet(wb, ws,'Expiry Report');
		XLSX.writeFile(wb,title); 

    for(let i=0;i<this.ListOfFinalData.length;i++){
      if(this.ListOfFinalData[i].status == 'Expired') {
        this.ListOfFinalData[i].status = 1;
      }else {
        this.ListOfFinalData[i].status = 0;
      }
    }
    console.log('2 ', this.ListOfFinalData)
  }
  getTechnicianName() {
    this.getBranchDetails();
   // this.loading=true;
    //  let techObj = {
    //     'orgId':this.orgId
    //   }
    // return this.http.post('/api/getTechniciansName', techObj).subscribe(
    //   res => {
      
    //     // this.loading=false;
    //       res.json();
    //     this.ListTechnicianName = res.json();
    //       let technicianArr = []
    //       for(var i=0;i<this.ListTechnicianName.length;i++) {
    //         let obj = {
    //           'label':this.ListTechnicianName[i].FIRST_NAME +' '+ this.ListTechnicianName[i].LAST_NAME,
    //           'value':this.ListTechnicianName[i].ID
    //         }
    //         technicianArr.push(obj);
    //       }
    //       this.techinicianDetails = technicianArr;
    //       this.getBranchDetails();
    // },(err)=>{
    //   this.loading=false;
    //   this.getBranchDetails();
    // })
  }

  viewHistory(pmId, serialNumber) {
    this.loading=true;
    let ReqObjValue = {
      'pmId':pmId
    }
    return this.http.post('/api/getHistoryDetailsBasedOnContractLevel', ReqObjValue).subscribe(
      res=>{ 
       
        this.ListAllHistroyDetails = [];
        this.listContractLevel=[];
        this.finalArr=[];
        this.loading=false;
        this.histroy = res.json();
        for(let h=0;h<this.histroy.length;h++) {
          for(var k =0;k<this.customerDetails.length;k++) {
              if( this.histroy[0].client_Name == this.customerDetails[k].Id){
                this.clientName = this.customerDetails[k].Name
              }
            }
            this.extensionUpdateId = this.histroy[h]._id
            for(let m=0;m<this.AllMakedetails.length;m++ ) {
              if(this.AllMakedetails[m]._id == parseInt(this.histroy[h].make)) {
                this.make = this.AllMakedetails[m].make;
              }
            }


            for(let n=0;n<this.ListbranchDetails.length;n++){
              if(this.ListbranchDetails[n]._id==this.histroy[h].branch){
               this.histroy[h].branch=this.ListbranchDetails[n].branchAlias
              }
            }

            for(let md=0;md<this.AllModalDetails.length;md++ ) {
              if(this.AllModalDetails[md]._id == parseInt(this.histroy[h].model)) {
                this.model = this.AllModalDetails[md].model;
              }
            }
            for(let t=0;t<this.techinicianDetails.length;t++) {
              if(this.techinicianDetails[t].value == parseInt(this.histroy[h].technician_Name)) {
                this.technicianName = this.techinicianDetails[t].label;
              }
            }
            for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
              if(this.ListAllServcieType[ls]._id == parseInt(this.histroy[h].last_Service_Type)) {
                this.lastServiceType = this.ListAllServcieType[ls].servicetype;
              }
            }
            if((this.lastServiceType==undefined||this.lastServiceType=="")&&this.histroy[h].last_Service_Type=="New Vehicle"){
              this.lastServiceType="New Vehicle"
             }
            for(let i=0;i<this.histroy[h].Servicedetails.length;i++) {
              for(let k=0;k<this.ListAllServcieType.length;k++) {
                if(parseInt(this.histroy[h].Servicedetails[i].service_Type) == this.ListAllServcieType[k]._id) {
                  this.histroy[h].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
                }
              }
              
            }
            let histroyObject = {
              'clientName':this.clientName,
              'pmId':this.histroy[h]._id,
              'serialNumber':this.histroy[h].serial_Number,
              'mcLocation':this.histroy[h].mcLocation,
              'phoneNumber':this.histroy[h].phone_Number,
              'email':this.histroy[h].email,
              'make':this.make,
              'modal':this.model,
              'hmr':this.histroy[h].hmr,
              'contractLevel':this.histroy[h].contractLevel,
              'technicianName':this.technicianName,
              'lastserviceType':this.lastServiceType,
              'lastServiceHours':this.histroy[h].last_Service_Hours,
              'yearOfManufacturer':this.histroy[h].year_Of_manufacturer,
              'serviceContractOfferedYear':this.histroy[h].service_Contract_Offered,
              'branch':this.histroy[h].branch,
              'contractRefernce':this.histroy[h].contract_Reference,
              'noofServiceContractYears':this.histroy[h].noofServiceContractYear,
              'startDate':moment(this.histroy[h].start_Date).format("D MMM YYYY"),
              'endDate':moment(this.histroy[h].end_Date).format("D MMM YYYY"),
              'newstartdate':this.histroy[h].start_Date,
              'newenddate':this.histroy[h].end_Date,
              'noOfservice':this.histroy[h].no_Of_Service,
              'serviceRemainderDays':this.histroy[h].remainderday,
              'currentService':this.histroy[h].serviceScheduleDay,
              'ListserviceDetails': this.histroy[h].Servicedetails,
              'histroyPr':[],
              'histroyPp':[],
              'ServiceContractExtend':[]

            }
            let clObj = {
              'contractLevel':this.histroy[h].contractLevel
            }
            this.listContractLevel.push(clObj);
            this.ListAllHistroyDetails.push(histroyObject);
            //this.showAlert();
        } //histroy for loop end here
      
        let reqObj = {
          'serialNumber':serialNumber
        }
        return this.http.post('/api/getListAllPostPonedHistroy', reqObj).subscribe(
        res=>{ 
          this.loading=false;
      
          let ppHis = res.json();
           this.histroyPP = [];
           this.histroyPr = [];
           if(ppHis.length>0) {
            for(var p=0;p<ppHis.length;p++) {
              if(ppHis[p].type == 'servicePrepone') {
                let pphis = {
                  'serialNumber':ppHis[p].serialNumber,
                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
                  'contractLevel': ppHis[p].contractLevel,
                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
                  'schedularNumber':ppHis[p].schedularNumber
                }
                this.histroyPr.push(pphis);
                for(let pr=0;pr<this.ListAllHistroyDetails.length;pr++) {
                  if(this.ListAllHistroyDetails[pr].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pr].contractLevel == ppHis[p].contractLevel) {
                    this.ListAllHistroyDetails[pr].histroyPr = this.histroyPr;
                  }
                } //for loop end here
              } else if(ppHis[p].type == 'servicePostpone') {
                let pphis = {
                  'serialNumber':ppHis[p].serialNumber,
                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date).format("D MMM YYYY"),
                  'contractLevel': ppHis[p].contractLevel,
                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
                  'schedularNumber':ppHis[p].schedularNumber
                }
                this.histroyPP.push(pphis);
                for(let pp=0;pp<this.ListAllHistroyDetails.length;pp++) {
                  if(this.ListAllHistroyDetails[pp].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pp].contractLevel == ppHis[p].contractLevel) {
                    this.ListAllHistroyDetails[pp].histroyPp = this.histroyPP;
                  }
                } //for loop end here
              }

              
              
            }
          }
          
          let reqExtendobj = {
            'serialNumber':serialNumber
          }
          return this.http.post('/api/getListAllServiceContractExtendHistroy', reqObj).subscribe(
          res=>{ 
       
            this.loading=false;
            let SCExtend = res.json();
            this.ServiceContractExtend = [];
            if(SCExtend.length>0) {
              for(var n=0;n<SCExtend.length;n++) {
                let SCEobj = {
                  'serialNumber':SCExtend[n].serialNumber,
                  'startdate':moment(SCExtend[n].startdate).format("D MMM YYYY"),
                  'enddate':moment(SCExtend[n].enddate).format("D MMM YYYY"),
                  'contractExtensionDate':moment(SCExtend[n].contractExtensionDate).format("D MMM YYYY")
                }
                this.ServiceContractExtend.push(SCEobj);
                for(let p=0;p<this.ListAllHistroyDetails.length;p++) {
                  if(this.ListAllHistroyDetails[p].serialNumber == SCExtend[n].serialNumber && this.ListAllHistroyDetails[p].contractLevel == SCExtend[n].contractLevel) {
                    this.ListAllHistroyDetails[p].ServiceContractExtend = this.ServiceContractExtend;
                  }
                } //for loop end here
              }
             
            }
         
            console.log('Final List ' + this.ListAllHistroyDetails);
            let statusObj = {
              'pmId':pmId,
              'serialNumber':this.ListAllHistroyDetails[0].serialNumber
            }
            return this.http.post('/api/serviceStatusChecking_serviceFormAPI', statusObj).subscribe(
            res => {
          
              let response = res.json();
              if(response.length > 0) {
                if(response[response.length-1].service_Scheduler_Number == this.ListAllHistroyDetails[0].noOfservice && response[response.length-1].status == 1) {
                  this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'completed';
                } else {
                  this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'notcompleted';
                }
              }
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              let finalObj = {
                'datavalue':this.ListAllHistroyDetails,
                'datacount':this.listContractLevel
              }
              this.finalArr.push(finalObj);
              this.showAlert();
            })
           
          },(err)=>{
            this.loading=false;
            console.log(err);
          
          })
          
        },(err)=>{
          this.loading=false;
          console.log(err);
          
        })
        
      },(err)=>{
        this.loading=false;
        console.log(err);
       
      })
     
  }

  close() {
    this.Histroy.hide();
  }

	getAllDetailsFromCustomerMaster () {
    // this.loading=true;
    let customerObj = {
      'orgId':this.orgId
    }
  		return this.http.post('/api/getCustomerMasterDetails', customerObj).subscribe(
     	res => {
         // this.loading=false;
     		
     		this.ListOfCustomerMaster = res.json();
     		for(var i=0;i<this.ListOfCustomerMaster.length;i++) {
     			let obj = {
     				'Id':this.ListOfCustomerMaster[i]._id,
     				'Name':this.ListOfCustomerMaster[i].customer_Name
     			}
     			this.customerDetails.push(obj);
     		}
         this.getAllServiceTypeDetails();
      	},(err)=>{
          this.loading=false;
          this.getAllServiceTypeDetails();
        })
  	}

  	getAlldetails() {
      // this.loading=true;
     
  		let RequiredObj = {
  			 'orgId':this.orgId
  		}
  		return this.http.post('/api/ReportAllCustomerStatus', RequiredObj).subscribe(
	    res=>{ 
        //this.loading=false;
	    	this.response = res.json();
        
	    	if(this.response.length>0) {
        this.ListOfFinalData=[];
        
        for(var i=0;i<this.response[1].register.length;i++) {
          
          let firstDate = new Date(moment(this.response[1].register[i].start_Date).format('YYYY MM DD'));
          let secondDate = new Date(moment(this.response[1].register[i].end_Date).format('YYYY MM DD'));
          let currentdate = new Date(moment().format('YYYY MM DD'));
          let oneDay = 24*60*60*1000;
          this.daysCount = Math.round(Math.abs((secondDate.getTime() - currentdate.getTime())/(oneDay)));
          this.response[1].register[i].days = this.daysCount;
          
          //this.daysCount = start.diff(end, 'days').asDays();
          for(var k=0;k<this.customerDetails.length;k++) {
            if(parseInt(this.response[1].register[i].client_Name) == this.customerDetails[k].Id){
            this.response[1].register[i].client_Name = this.customerDetails[k].Name;
            } 
          }
        }
        let statusvalue=0;
        this.getExpireDetails()
        // for(var i=0;i<this.response[1].register.length;i++) {
        //   for(let s=0;s<this.response[0].service.length;s++) {
        //     if(this.response[1].register[i].serial_Number == this.response[0].service[s].serialNumber && this.response[1].register[i].contractLevel == this.response[0].service[s].contractLevel) {
        //       statusvalue = this.response[0].service[s].status;
        //     }
        //   }
        //   let obj = {
        //     'client_Name':this.response[1].register[i].client_Name,
        //     'id':this.response[1].register[i]._id,
        //     'mcLocation':this.response[1].register[i].mcLocation,
        //     'contractLevel':this.response[1].register[i].contractLevel,
        //     'contract_Reference':this.response[1].register[i].contract_Reference,
        //     'serial_Number':this.response[1].register[i].serial_Number,
        //     'start_Date':moment(this.response[1].register[i].start_Date).format("D MMM YYYY"),
        //     'end_Date':moment(this.response[1].register[i].end_Date).format("D MMM YYYY"),
        //     'STARTDATE':this.response[1].register[i].start_Date,
        //     'ENDDATE':this.response[1].register[i].end_Date,
        //     'serviceScheduleDay':this.response[1].register[i].serviceScheduleDay,
        //     'noofServices':this.response[1].register[i].no_Of_Service,
        //     'days':this.response[1].register[i].days,
        //     'status':statusvalue
        //   }
        //    this.ListOfFinalData.push(obj);
        // }
         
        //   console.log('this.ListOfFinalData ' + this.ListOfFinalData);
        //   this.loading=false;
          this.getCount();
        } else {
          this.loading=false;
        }
	    	
	    },(err)=>{
        this.loading=false;
      })	
  	}

  	Search(value) {
  		// if(value == 'Select All') {
  		// 	this.getAlldetails();
  		// } else 
      if(value == 'Expired') {
  			this.getExpireDetails();
  		} else if(value == 'Need To Renewal') {
        this.getRenewal();
      }
  	}

  	getExpireDetails() {
      this.loading=true;
         this.ListOfExpiryreport = [];
      this.ListOfFinalData=[];
      let statusvalue=0;
          for(var i=0;i<this.response[1].register.length;i++) {
            if(this.response[1].register[i].end_Date<moment().format('YYYY-MM-DD')){
          for(var j=0;j<this.response[0].service.length;j++) {
            if(this.response[0].service[j].serialNumber == this.response[1].register[i].serial_Number && parseInt(this.response[0].service[j].service_Scheduler_Number)<= this.response[1].register[i].no_Of_Service && this.response[0].service[j].status == 0 && this.response[0].service[j].contractLevel == this.response[1].register[i].contractLevel){
              this.ListOfExpiryreport.push(this.response[1].register[i]);
            }
          }
        }
        }
    	
    	// for(var i=0;i<FinalArr.length;i++) {
    	// 	this.ListOfExpiryreport.push(FinalArr[i]);
        
    	// }
      for(var i=0;i<this.ListOfExpiryreport.length;i++) {
        // for(let s=0;s<this.response[0].service.length;s++) {
        //   // if(this.ListOfExpiryreport[i].serial_Number == this.response[0].service[s].serialNumber && this.ListOfExpiryreport[i].contractLevel == this.response[0].service[s].contractLevel) {
        //   if(this.ListOfExpiryreport[i].serial_Number == this.response[0].service[s].serialNumber && this.ListOfExpiryreport[i].contractLevel == this.response[0].service[s].contractLevel) {
        //     statusvalue = this.response[0].service[s].status;
        //   }
        // }
        let Reqobj = {
          'client_Name':this.ListOfExpiryreport[i].client_Name,
          'mcLocation':this.ListOfExpiryreport[i].mcLocation,
          'contractLevel':this.ListOfExpiryreport[i].contractLevel,
          'contract_Reference':this.ListOfExpiryreport[i].contract_Reference,
          'serial_Number':this.ListOfExpiryreport[i].serial_Number,
          'start_Date':moment(this.ListOfExpiryreport[i].start_Date).format("D MMM YYYY"),
          'end_Date':moment(this.ListOfExpiryreport[i].end_Date).format("D MMM YYYY"),
          'STARTDATE':this.ListOfExpiryreport[i].start_Date,
          'ENDDATE':this.ListOfExpiryreport[i].end_Date,
          'id':this.ListOfExpiryreport[i]._id,
          'serviceScheduleDay':this.ListOfExpiryreport[i].serviceScheduleDay,
          'days':this.ListOfExpiryreport[i].days
          // ,
          // 'status':statusvalue
        }
        this.ListOfFinalData.push(Reqobj);
      }
      console.log("expiry ", this.ListOfFinalData)
      this.loading=false;
      this.getCount();
        
    	
	}



  getRenewal() {
    
    this.loading=true;
    this.ListOfNeedToRenewal = [];
      this.ListOfFinalData=[];
      for(var i=0;i<this.response[1].register.length;i++) {
        if(this.response[1].register[i].days<=30 && this.response[1].register[i].days>=0 && this.response[1].register[i].end_Date >= this.todaydate){
          for(var j=0;j<this.response[0].service.length;j++) {
            if(this.response[0].service[j].serialNumber == this.response[1].register[i].serial_Number && parseInt(this.response[0].service[j].service_Scheduler_Number)<= this.response[1].register[i].no_Of_Service && this.response[0].service[j].status == 0 && this.response[0].service[j].contractLevel == this.response[1].register[i].contractLevel){
              let firstDate = new Date(moment(this.response[1].register[i].start_Date).format('YYYY MM DD'));
              let secondDate = new Date(moment(this.response[1].register[i].end_Date).format('YYYY MM DD'));
              let currentdate = new Date(moment().format('YYYY MM DD'));
              let oneDay = 24*60*60*1000;
              this.daysCount = Math.round(Math.abs((secondDate.getTime() - currentdate.getTime())/(oneDay)));
              this.response[1].register[i].days = this.daysCount;
              this.ListOfNeedToRenewal.push(this.response[1].register[i]);
            }
          }
          
        }
      }
      
     
      for(var i=0;i<this.ListOfNeedToRenewal.length;i++) {
        let Reqobj = {
          'client_Name':this.ListOfNeedToRenewal[i].client_Name,
          'mcLocation':this.ListOfNeedToRenewal[i].mcLocation,
          'contractLevel':this.ListOfNeedToRenewal[i].contractLevel,
          'contract_Reference':this.ListOfNeedToRenewal[i].contract_Reference,
          'serial_Number':this.ListOfNeedToRenewal[i].serial_Number,
          'start_Date':moment(this.ListOfNeedToRenewal[i].start_Date).format("D MMM YYYY"),
          'end_Date':moment(this.ListOfNeedToRenewal[i].end_Date).format("D MMM YYYY"),
          'STARTDATE':this.ListOfNeedToRenewal[i].start_Date,
          'ENDDATE':this.ListOfNeedToRenewal[i].end_Date,
          'id':this.ListOfNeedToRenewal[i]._id,
          'serviceScheduleDay':this.ListOfNeedToRenewal[i].serviceScheduleDay,
          'days':this.ListOfNeedToRenewal[i].days
        }
        this.ListOfFinalData.push(Reqobj);
        console.log('renewal data ', this.ListOfFinalData)
      }
      this.loading=false;
      this.getCount();
  }

  contractExtension() {
    
    this.Histroy.hide();

    this.newserialNumber = this.serialNumber;
    this.ContractExtension.options = {
      showButtons: false, // You can hide this in case you want to use custom 
      color: "#4180ab",
      widthProsentage:50,
      header: "Contract Extension"
    };
    this.ContractExtension.show(this.ContractExtension.options);

  }
  cancel() {
    this.ContractExtension.hide();
  }
  

  save() {
    this.loading=true;
    let CEobj = {
      'serialNumber':this.newserialNumber,
      'startDate':this.newstartdate,
      'endDate':this.newenddate,
      'extensionDate':this.newextensiondate,
      'PM_ID':this.extensionUpdateId,
      'orgId':this.orgId,
      'created_By':this.userId,
      'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
    }
    return this.http.post('/api/extendServiceContractDuration', CEobj).subscribe(
    res=>{
      this.loading=false;
      let Response = res.json();
      alert('service contract Extension successfully done.');
      this.getAlldetails();
      this.ContractExtension.hide();
    },(err)=> {
      this.loading=false;
      alert('unable to extend the service contract');
    })

  }
  	

  

}



// WEBPACK FOOTER //
// ./client/app/status-report-one-month-before/status-report-one-month-before.component.ts